import { render } from "./ImageCardSkeleton.vue?vue&type=template&id=48c89dce&scoped=true"
const script = {}

import "./ImageCardSkeleton.vue?vue&type=style&index=0&id=48c89dce&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\artware\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48c89dce"]])

export default __exports__